import React from 'react';
import PropTypes from 'prop-types';
import { ApolloProvider } from '@apollo/client';
import { ThemeProvider, createTheme } from '@material-ui/core/styles';
import { EditLedger as EditLedgerComponent } from 'edit-ledger-form';
import { graphqlClient } from 'bk-web-app';
import teal from '@material-ui/core/colors/teal';

const labelStyle = {
  textTransform: 'uppercase',
  fontSize: '10px',
  fontWeight: 700,
  color: '#484B50',
  letterSpacing: '2px',
};

const theme = createTheme({
  palette: {
    primary: teal,
  },
  typography: {
    fontFamily: `"LLCircularWeb-Book", "Helvetica Neue", Helvetica, Arial, sans-serif`,
  },
  overrides: {
    MuiInputBase: {
      input: {
        height: '100%',
      },
    },
    MuiFilledInput: {
      root: {
        backgroundColor: '#F7F8FA !important',
        '&:hover': {
          backgroundColor: '#F7F8FA',
        },
      },
      input: {
        height: '100%',
      },
    },
    MuiGrid: {
      container: {
        marginTop: '1rem',
      },
    },
    MuiFormLabel: {
      root: labelStyle,
    },
    MuiFormControlLabel: {
      root: {
        marginLeft: '0 !important',
        alignItems: 'start',
        width: '100%',
      },
      label: labelStyle,
    },
  },
});

function EditLedger(props) {
  return (
    <ApolloProvider client={graphqlClient}>
      <ThemeProvider theme={theme}>
        <EditLedgerComponent {...props} />
      </ThemeProvider>
    </ApolloProvider>
  );
}

EditLedger.propTypes = {
  clientId: PropTypes.number,
  ledgerId: PropTypes.number,
  onClose: PropTypes.func,
};

EditLedger.defaultProps = {
  clientId: null,
  ledgerId: null,
  onClose: () => {},
};

export default EditLedger;
